import { render } from "./Actors.vue?vue&type=template&id=f820a660"
import script from "./Actors.vue?vue&type=script&lang=js"
export * from "./Actors.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__